<template>
  <div class="pop-box">
    <el-form
      label-position="top"
      label-width="140px"
      :model="formLabelAlign"
    >
      <div class="pop-title">基础信息</div>
      <div class="pop-cell">
        <!-- style="display: flex; flex-direction: column;" -->
        <el-form-item label="登录平台:" position="top">
          <el-radio-group
            v-model="rule_type"
            :disabled="type === 2 || isExternal"
            @change="loginplarm"
          >
            <!-- 使用 v-for 渲染多个 el-radio -->
            <el-radio
              v-for="items in filteredOptions"
              :key="items.value"
              :label="items.value"
              style="width:20%;"
            >
              {{ items.key }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="来源类型:">
          <el-radio-group
            v-model="source"
            :disabled="type === 2"
          >
            <el-radio
              v-for="items in sourceTypeOptions"
              :key="items.value"
              :label="items.value"
              style="width:20%;"
            >
              {{ items.key }}
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="群名称:">
          <div style="display:flex; align-items:center;">
            <el-input
              v-model="textarea"
              placeholder="请输入群名称"
              style="width:320px;"
              @blur="handleInputBlur"
            />
            <el-button
              type="primary"
              size="mini"
              style="height:32px;margin-left:10px;"
              @click="addidentifit"
            >添加群编号</el-button>
          </div>
        </el-form-item>
      </div>
      <div class="pop-cell">
        <el-form-item label="来源类型:">
          <el-radio-group
            v-model="source"
            :disabled="type === 2"
          >
            <el-radio
              v-for="items in sourceTypeOptions"
              :key="items.value"
              :label="items.value"
              style="width:20%;"
            >
              {{ items.key }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="pop-title">人员配置</div>
      <div class="pop-cell">
        <el-form-item label="群主">
          <div style="display:flex;">
            <div class="put-box">
              <el-tag
                v-if="employee_no != ''"
                style="margin-left: 10px"
              >{{ name }}</el-tag>
            </div>
            <el-button
              type="primary"
              :disabled="type === 2"
              size="mini"
              @click="choose"
            >选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="发言人">
          <div style="display:flex;">
            <div class="put-box">
              <span v-if="corp_iduser.length !== 0">
                <el-tag
                  v-for="(item, index) in corp_iduser"
                  :key="index"
                  closable
                  style="margin-left: 10px"
                  @close="handleClose(item, index)"
                >{{ item.nickname }}</el-tag>
              </span>
            </div>

            <el-button
              type="primary"
              size="mini"
              :disabled="employee_no === ''"
              @click="chooseidsr"
            >选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="拉人员工">
          <div style="display:flex;">
            <div class="put-box">
              <span v-if="corp_iduser_group.length !== 0">
                <el-tag
                  v-for="(item, index) in corp_iduser_group"
                  :key="index"
                  closable
                  style="margin-left: 10px"
                  @close="handleCloseGroup(item, index)"
                >{{ item.name }}</el-tag>
              </span>
            </div>
            <el-button
              :disabled="employee_no === ''"
              type="primary"
              size="mini"
              @click="handlegroup"
            >选择</el-button>
          </div>
        </el-form-item>
      </div>
      <div class="pop-title">时间配置</div>
      <div class="pop-cell">
        <el-form-item
          v-if="corp_iduser_group.length !== 0"
          label="标签组"
        >
          <div class="corp_box">
            <el-tree
              ref="tree"
              :data="data"
              show-checkbox
              default-expand-all
              node-key="id"
              highlight-current
              :default-checked-keys="allarr"
              :props="defaultProps"
            />
          </div>
        </el-form-item>
        <el-form-item label="添加时间">
          <div style="display: flex; align-items: center">
            <el-radio-group
              v-model="chat_set_type"
              :disabled="type == 2"
            >
              <el-radio :label="1">默认</el-radio>
              <el-radio :label="2">固定天数</el-radio>
              <el-radio :label="3">指定日期</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item
          v-if="chat_set_type == 2"
          label="固定天数"
        >
          <div class="taewr">
            <div class="tiwmeboxr">前</div>
            <el-input
              v-model="fixed_number_of_days"
              :disabled="type == 2"
              type="number"
              style="width: 320px"
              @blur="dayewr"
            />
            <div class="tiwmebox">天</div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="chat_set_type == 3"
          label="指定日期"
        >
          <el-date-picker
            v-model="timearr"
            :disabled="type == 2"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 320px"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="datavalue"
          />
        </el-form-item>
      </div>
      <div class="pop-title">更多配置</div>
      <div class="pop-cell">
        <el-form-item label="最大人数上限" style="position:relative;">
          <el-input-number
            v-model="max_number"
            :min="1"
            label="最大人数上限"
            style="width:320px"
          />
          <span style="color: red; font-size:10px; position:absolute;right:30px;bottom:-30px;">*人数上限包括发言人</span> </el-form-item>
        <el-form-item label="每日群聊创建上限">
          <el-input-number
            v-model="max_num_daily"
            :min="1"
            style="width:320px"
            label="最大人数上限"
          />
        </el-form-item>
      </div>
      <div class="pop-cell">
        <el-form-item
          v-show="rule_type === 2"
          label="本次拉群数量"
        >
          <el-input-number
            v-model="pull_group_num"
            :min="1"
            label="最大人数上限"
            style="width:320px"
          />
        </el-form-item>
        <el-form-item
          v-show="rule_type === 2"
          label="拉群方式"
        >
          <el-select
            v-model="pull_group_people"
            class="add_name"
            style="width:320px"
          >
            <el-option
              v-for="items in groupType"
              :key="items.key"
              :label="items.key"
              :value="items.value"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="pop-cell">
        <!-- 新增：是否快速配置模板 -->
        <el-form-item v-show="(rule_type == 1 || rule_type == 3)" label="是否快速配置模板">
          <el-radio-group v-model="is_quick_template">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="2">否</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 当选择快速配置时，只显示快速配置模板字段 -->
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 1" label="快速配置模板">
          <el-input
            v-model="templateText"
            show-word-limit
            placeholder="请输入快速配置模板"
            style="width:320px"
            @input="handleTemplateInput"
          />
        </el-form-item>
      </div>
      <div class="pop-cell">
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="是否禁止改群名">
          <div style="display: flex; align-items: center">
            <el-radio-group v-model="change_chat_name">
              <el-radio :label="1">禁止</el-radio>
              <el-radio :label="2">允许</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="是否禁止群内互加好友">
          <div style="display: flex; align-items: center">
            <el-radio-group v-model="mutually_add_friend">
              <el-radio :label="1">禁止</el-radio>
              <el-radio :label="2">允许</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

      </div>
      <div class="pop-cell">
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="自动回复">
          <el-radio-group v-model="auto_reply">
            <el-radio :label="2">不开</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="邀请确认按钮">
          <el-radio-group v-model="invite_confirm">
            <el-radio :label="2">不开</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="pop-cell">
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="欢迎语间隔">
          <el-select v-model="welcome_interval" placeholder="请选择欢迎语间隔" style="width:320px" :disabled="rule_type == 1">
            <el-option label="3分钟" :value="1" />
            <el-option label="10分钟" :value="2" />
            <el-option label="30分钟" :value="3" />
            <el-option label="60分钟" :value="4" />
          </el-select>
        </el-form-item>

        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="入群欢迎语">
          <el-input
            v-model="welcomeText"
            maxlength="50"
            show-word-limit
            placeholder="请输入入群欢迎语"
            style="width:320px"
            @input="handleWelcomeInput"
          />
        </el-form-item>

      </div>
      <div class="pop-cell">
        <el-form-item v-show="(rule_type == 1 || rule_type == 3) && is_quick_template == 2" label="防骚扰">
          <el-input
            v-model="avoid_harass_input"
            placeholder="输入关键词，回车添加"
            style="width:100%;"
            @keyup.enter.native="addAvoidHarassTag"
          />
          <div style="margin-top: 10px;">
            <el-tag
              v-for="(tag, index) in avoid_harass"
              :key="index"
              closable
              style="margin-right: 5px;"
              @close="removeAvoidHarassTag(index)"
            >
              {{ tag }}
            </el-tag>
          </div>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button
          type="primary"
          class="submit-btn"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择人员"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <spword
        ref="spwordview"
        @spWork="spWork"
      />
    </el-dialog>
    <el-dialog
      title="选择发言人"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="选择发言人"
      :visible.sync="dialogVisiblepaiwer"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <groupsendfayan
        ref="groupsendfayanview"
        @bandarr="bandarrpaiwer"
      />
    </el-dialog>
    <el-dialog
      title="拉人员工"
      :visible.sync="dialoggroup"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <groupsend
        ref="groupsend"
        @bandarr="bandarrgroup"
      />
    </el-dialog>
    <el-dialog
      title="拉人员工"
      :visible.sync="dialogroupsendphone"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <groupsendphone
        ref="groupsendphoneview"
        @bandarr="bandarrgroup"
      />
    </el-dialog>
  </div>
</template>

<script>
import spword from './spword.vue'
import bandstaff from './bandstaff.vue'
import groupsend from './groupsend.vue'
import groupsendphone from './groupsendphone.vue'
import groupsendfayan from './groupsendfayan.vue'
import { groupChatSetcreate, editAutomaticType, groupChatSetindex /* spCorpcorpUsersList, setReceiveMiniprogram */ } from '@/api/officialaccount.js'
import { corpTag } from '@/api/officialaccount.js'
export default {
  components: { spword, bandstaff, groupsend, groupsendphone, groupsendfayan },
  data() {
    return {
      formLabelAlign: {},
      dialogVisible: false,
      dialogVisibler: false,
      corp_iduser: [],
      corp_iduserWxId: [],
      allcorp_iduser: [],
      employee_no: '',
      name: '',
      textarea: '',
      id: null,
      type: null,
      group_chat_name_rule: null,
      blurIndex: null,
      addtifit: '{number}',
      options: [
        {
          value: 1,
          key: '由创'
        },
        {
          value: 2,
          key: '企微宝'
        },
        {
          value: 3,
          key: '手机企微'
        }
      ],
      sourceTypeOptions: [
        {
          value: 1,
          key: '系统构建'
        },
        {
          value: 2,
          key: '外部构建'
        }
      ],
      source: 1,
      groupType: [
        {
          value: 1,
          key: '边建群边拉人'
        },
        {
          value: 2,
          key: '建完群再拉人'
        }
      ],
      max_number: 40,
      max_num_daily: 20,
      pull_group_num: 40,
      corp_id: null,
      dialoggroup: false,
      corp_iduser_group: [],
      onlyme: null,
      data: [],
      alltagarr: [],
      corp_ids: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      arrse: [],
      allarr: [],
      corp_namec: '',
      chat_set_id: null,
      timearr: [],
      chat_set_type: 1,
      fixed_number_of_days: 1,
      starttime: '',
      endtime: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      chat_set_where: {},
      init_corp_iduser: [],
      missingIds: [],
      rule_type: 1,
      pull_group_people: 1,
      isExternal: false, // 是否为外部用户
      dialogroupsendphone: false,
      dialogVisiblepaiwer: false,
      change_chat_name: 1,
      mutually_add_friend: 1,
      is_quick_template: 2, // 是否快速配置模版
      templateText: '', // 快速配置模板，文本输入，最大50字符
      welcomeText: '', // 入群欢迎语，文本输入，最大50字符
      auto_reply: 2, // 自动回复，默认1（2：不开，1：开启）
      avoid_harass: [], // 存储防骚扰关键词的数组
      avoid_harass_input: '', // 输入框绑定的值
      invite_confirm: 2, // 邀请确认按钮，默认1（2：不开，1：开启）
      welcome_interval: 1 // 欢迎语间隔，默认1（1：3分钟，2：10分钟，3：30分钟，4：60分钟）
    }
  },
  computed: {
    // 根据 isExternal 过滤登录平台选项
    filteredOptions() {
      if (this.isExternal) {
        // 外部用户只显示"手机企微"选项
        return this.options.filter(item => item.value === 3)
      }
      return this.options
    }
  },
  created() {},
  mounted() {},
  methods: {
    handlegroup() {
      if (this.rule_type === 3) {
        this.dialogroupsendphone = true
        console.log('(this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec:', this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec)
        this.$nextTick(() => {
          this.$refs.groupsendphoneview.sendr(this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec)
        })
      } else {
        this.dialoggroup = true
        this.$nextTick(() => {
          console.log('(this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec:', this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec)
          this.$refs.groupsend.sendr(this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec)
        })
      }
    },
    choose() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.spwordview.open(1)
      })
    },
    spWork(item) {
      console.log('item', item)
      if (this.employee_no !== item.employee_no) {
        this.corp_iduser = []
      }
      this.employee_no = item.employee_no
      this.name = item.name
      this.dialogVisible = false
      // eslint-disable-next-line eqeqeq
      console.log(this.employee_no, item.employee_no)
      this.corp_id = item.corp_id
      this.corp_namec = item.corp_name
      console.log(item)
      // eslint-disable-next-line eqeqeq
      if (item.wx_id != '' && this.rule_type != 3) {
        this.corp_iduser = [{ friend_id: item.wx_id, nickname: item.name }]
      }
    },
    chooseidsr(number) {
      if (this.rule_type === 3) {
        this.dialogVisiblepaiwer = true
        // console.log('(this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec:', this.employee_no, this.corp_id, this.corp_iduser_group, this.corp_namec)
        this.$nextTick(() => {
          this.$refs.groupsendfayanview.sendr(this.employee_no, this.corp_id, this.corp_iduser, this.corp_namec)
        })
      } else {
        this.dialogVisibler = true
        this.$nextTick(() => {
          this.$refs.bandstaffview.sendr(this.corp_iduser, this.employee_no, this.corp_id, number, true, this.rule_type)
        })
      }
    },
    async bandarr(corp_iduser, employee_no, number) {
      console.log('number:', number, corp_iduser)
      this.dialogVisibler = false
      if (number === 2) {
        corp_iduser.forEach(e => {
          this.corp_iduserWxId = corp_iduser
        })
      } else {
        this.corp_iduser = corp_iduser
      }
    },
    bandarrpaiwer(friendarr) {
      this.dialogVisiblepaiwer = false
      this.corp_iduser = []
      this.corp_iduser = friendarr
    },
    async bandarrgroup(corp_iduser, employee_no, corp_ids) {
      console.log(111)
      if (this.rule_type === 3) {
        this.dialogroupsendphone = false
      } else {
        this.dialoggroup = false
      }
      this.corp_iduser_group = corp_iduser
      this.corp_ids = []
      this.corp_ids = corp_ids
      console.log('corp_iduser', corp_iduser)
      this.gettree()
    },
    send(type, item, onlyme, external) {
      console.log('onlyme', onlyme, 'external', external)
      this.onlyme = onlyme
      this.isExternal = external || false
      // 如果是外部用户，强制设置为手机企微（rule_type = 3）
      if (this.isExternal) {
        this.rule_type = 3
      }
      // if (onlyme === 1) {
      //   this.onlyme = onlyme
      // } else {
      //   this.onlyme = null
      // }
      if (type === 1) {
        this.type = type
        this.source = 1
      } else {
        console.log('编辑', item, item.chat_set_type)
        console.log(JSON.parse(item.tag_ids))
        this.type = type
        this.chat_set_type = item.chat_set_type
        // eslint-disable-next-line eqeqeq
        if (item.chat_set_type == 2) {
          this.fixed_number_of_days = item.chat_set_where.fixed_number_of_days
        }
        // eslint-disable-next-line eqeqeq
        if (item.chat_set_type == 3) {
          // timestampToTime
          console.log('itemr', this.timestampToTime(item.chat_set_where.start_time), this.timestampToTime(item.chat_set_where.end_time))
          this.timearr = [this.timestampToTime(item.chat_set_where.start_time), this.timestampToTime(item.chat_set_where.end_time)]
          this.starttime = this.timestampToTime(item.chat_set_where.start_time)
          this.endtime = this.timestampToTime(item.chat_set_where.end_time)
        }
        if (item.rule_type === 3 || item.rule_type === 1) {
          this.change_chat_name = item.change_chat_name
          this.mutually_add_friend = item.mutually_add_friend
          // eslint-disable-next-line eqeqeq
          if (item.template == '') {
            console.log('否')
            this.is_quick_template = 2
          } else {
            console.log('是')
            this.is_quick_template = 1
          }
        }
        this.employee_no = item.employee_no
        // 如果是外部用户，强制设置为手机企微（rule_type = 3），否则使用原值
        if (this.isExternal) {
          this.rule_type = 3
        } else {
          this.rule_type = item.rule_type
        }
        this.source = item.source || 1
        this.pull_group_people = item.pull_group_people
        this.chat_set_id = item.id
        this.corp_ids = item.corp_id
        this.templateText = item.template || ''
        this.welcomeText = item.welcome || ''
        this.auto_reply = item.auto_reply || 1
        this.avoid_harass = item.avoid_harass || []
        this.invite_confirm = item.invite_confirm || 1
        this.welcome_interval = item.welcome_interval || 1
        this.gettree()
        this.listr()
        this.allarr = JSON.parse(item.tag_ids)
      }
    },
    async listr() {
      this.loading = true
      const data = await groupChatSetindex({
        page: 1,
        page_size: 10,
        chat_set_id: this.chat_set_id,
        onlyMe: this.onlyme
      })
      console.log('data:', data)
      this.init_corp_iduser = JSON.parse(JSON.stringify(data.data.list[0].spokesman_user_text))
      this.corp_iduser = data.data.list[0].spokesman_user_text
      this.corp_iduser_group = data.data.list[0].pull_user_text.map(v => {
        return {
          name: v.nickname,
          employee_no: v.friend_id
        }
      })
      console.log(data.data.list[0].reverse_complement_wx_id)
      if (data.data.list[0].reverse_complement_wx_id !== '') {
        this.corp_iduserWxId = [
          {
            friend_id: data.data.list[0].reverse_complement_wx_id,
            nickname: data.data.list[0].reverse_complement_employee_name
          }
        ]
      }
      console.log(' this.corp_iduserWxId :', this.corp_iduserWxId)

      this.id = data.data.list[0].id
      this.name = data.data.list[0].corp_user_name
      this.textarea = data.data.list[0].group_chat_name_rule
      this.max_number = data.data.list[0].max_number
      this.max_num_daily = data.data.list[0].max_num_daily
      this.pull_group_num = data.data.list[0].pull_group_num
      this.corp_id = data.data.list[0].corp_id
    },
    async sumbit() {
      this.arrse = []
      console.log('this.data', this.data)
      this.arrse = this.fnTree(this.data).map(item => {
        return item.id
      })
      console.log('this.arrse', this.arrse)

      // for (let i = 0; i < this.arrse.length; i++) {
      //   for (let k = 0; k < this.$refs.tree.getCheckedNodes().length; k++) {
      //     // eslint-disable-next-line eqeqeq
      //     if (this.arrse[i] == this.$refs.tree.getCheckedNodes()[k].id) {
      //       this.allarr.push(this.$refs.tree.getCheckedNodes()[k].id)
      //     }
      //   }
      // }
      this.allarr = this.$refs.tree.getCheckedKeys(true) // 选中的标签组
      console.log('this.allarr', this.allarr)
      if (this.textarea === '') {
        this.$message.error('请输入群名称')
        return
      }
      var regex = /\{number\}/ // 匹配"{number}"
      if (!regex.test(this.textarea)) {
        this.$message.error('群名称必须包含"{number}"')
        return
      }
      if (this.employee_no === '') {
        this.$message.error('请选择人员')
        return
      }
      // if (this.corp_iduser.length === 0) {
      //   this.$message.error('请选择发言人')
      //   return
      // }
      if (this.corp_iduser_group.length === 0) {
        this.$message.error('请选择拉人的人')
        return
      }
      // eslint-disable-next-line eqeqeq
      // if (this.chat_set_type == 2) {
      //   this.$message.error('请选择固定天数')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      // if (this.chat_set_type == 3) {
      //   // eslint-disable-next-line eqeqeq
      //   if (this.starttime == '') {
      //     this.$message.error('请选择开始日期')
      //     return
      //   }
      //   // eslint-disable-next-line eqeqeq
      //   if (this.endtime == '') {
      //     this.$message.error('请选择结束日期')
      //     return
      //   }
      // }
      // if (this.allarr.length === 0) {
      //   this.$message.error('请选择标签组')
      //   return
      // }
      if (this.max_number === undefined) {
        this.$message.error('请输入最大人数上限')
        return
      }
      if (this.max_num_daily === undefined) {
        this.$message.error('请输入每日群聊创建上限')
        return
      }
      if (this.pull_group_num === undefined) {
        this.$message.error('请输入本次拉群数量')
        return
      }
      if (this.type === null) {
        this.$message.error('type丢失请关闭弹框')
        return
      }
      this.chat_set_where = {}
      if (this.type === 1) {
        console.log('新增')
        // eslint-disable-next-line eqeqeq
        await this.reuse()
      } else if (this.type === 3) {
        console.log('复用')
        await this.reuse()
      } else {
        console.log('编辑')
        this.allcorp_iduser = []
        const initIds = this.init_corp_iduser.map(e => e.nickname)
        const initName = []
        this.missingIds = initIds.filter(id => {
          console.log('initIds:', initIds, id)
          return !this.corp_iduser.some(user => user.nickname === id)
        })
        let hard_remove = null
        // this.init_corp_iduser.forEach(e => {
        //   this.missingIds.forEach(v => {
        //     if (e.nickname !== v) {
        //       console.log(e, '11')
        //       initName.push(e.nickname)
        //     }
        //   })
        // })
        let sign = null
        if (this.missingIds.length !== 0) {
          await this.$confirm(`本次修改是否要将本次去除的 ${this.missingIds.join(',')} 发言人踢出群？`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            distinguishCancelAndClose: true,
            type: 'warning'
          })
            .then(() => {
              hard_remove = 1
              sign = null
            })
            .catch(e => {
              console.log('e:', e)
              // eslint-disable-next-line eqeqeq
              if (e == 'cancel') {
                hard_remove = 0
                sign = null
                // eslint-disable-next-line eqeqeq
              } else if (e == 'close') {
                sign = 1
              }
            })
        }
        console.log(this.missingIds, initName, hard_remove, sign)

        if (sign === 1) return
        // if (sign === null) return
        this.allcorp_iduser = this.corp_iduser.map(item => {
          return item.friend_id
        })
        const pull_user_wx_ids = this.corp_iduser_group.map(v => v.employee_no)
        const editalbocxr = {}
        if (this.rule_type === 1 || this.rule_type === 3) {
          if (this.is_quick_template === 1) {
            editalbocxr.template = this.templateText
            editalbocxr.change_chat_name = null
            editalbocxr.mutually_add_friend = null
            editalbocxr.welcome = null
            editalbocxr.auto_reply = null
            editalbocxr.avoid_harass = []
            editalbocxr.invite_confirm = null
            editalbocxr.welcome_interval = null
          } else {
            editalbocxr.template = '' // 或者不传此字段
            editalbocxr.change_chat_name = this.change_chat_name
            editalbocxr.mutually_add_friend = this.mutually_add_friend
            editalbocxr.welcome = this.welcomeText
            editalbocxr.auto_reply = this.auto_reply
            editalbocxr.avoid_harass = this.avoid_harass
            editalbocxr.invite_confirm = this.invite_confirm
            editalbocxr.welcome_interval = this.welcome_interval
          }
        }
        const data = await editAutomaticType({
          // employee_no: this.employee_no,
          rule_type: this.rule_type,
          source: this.source,
          pull_group_people: this.pull_group_people,
          id: this.id,
          spokesman_wx_ids: this.allcorp_iduser,
          group_chat_name_rule: this.textarea,
          pull_user_wx_ids,
          max_number: this.max_number,
          max_num_daily: this.max_num_daily,
          pull_group_num: this.pull_group_num,
          tag_ids: this.allarr,
          chat_set_type: this.chat_set_type,
          hard_remove,
          ...editalbocxr
        })
        console.log('data111', data)
        if (data.code === 200) {
          this.resetFormData()
          this.$emit('updata')
        }
      }
    },
    resetFormData() {
      this.id = null
      this.source = 1
      this.name = ''
      this.textarea = ''
      this.max_number = 40
      this.max_num_daily = 20
      this.pull_group_num = 40
      this.corp_id = null
      this.corp_iduser = []
      this.corp_iduser_group = []
    },
    async reuse() {
      // eslint-disable-next-line eqeqeq
      if (this.chat_set_type == 2) {
        // eslint-disable-next-line eqeqeq
        if (this.fixed_number_of_days == '') {
          this.$message.error('请输入固定天数')
          return
        }
        this.chat_set_where.fixed_number_of_days = Number(this.fixed_number_of_days)
      }
      // eslint-disable-next-line eqeqeq
      if (this.chat_set_type == 3) {
        // eslint-disable-next-line eqeqeq
        if (this.starttime == '') {
          this.$message.error('请输入开始时间')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.endtime == '') {
          this.$message.error('请输入结束时间')
          return
        }
        this.chat_set_where.start_time = this.starttime
        this.chat_set_where.end_time = this.endtime
      }
      this.allcorp_iduser = []
      this.allcorp_iduser = this.corp_iduser.map(item => {
        return item.friend_id
      })
      const pull_user_wx_ids = this.corp_iduser_group.map(v => v.employee_no)
      const albocxr = {}
      if (this.rule_type === 1 || this.rule_type === 3) {
        if (this.is_quick_template === 1) {
          albocxr.template = this.templateText
          albocxr.change_chat_name = null
          albocxr.mutually_add_friend = null
          albocxr.welcome = null
          albocxr.auto_reply = null
          albocxr.avoid_harass = []
          albocxr.invite_confirm = null
          albocxr.welcome_interval = null
        } else {
          albocxr.template = ''
          albocxr.change_chat_name = this.change_chat_name
          albocxr.mutually_add_friend = this.mutually_add_friend
          albocxr.welcome = this.welcomeText
          albocxr.auto_reply = this.auto_reply
          albocxr.avoid_harass = this.avoid_harass
          albocxr.invite_confirm = this.invite_confirm
          albocxr.welcome_interval = this.welcome_interval
        }
      }
      console.log('reuse111')
      const data = await groupChatSetcreate({
        rule_type: this.rule_type,
        source: this.source,
        pull_group_people: this.pull_group_people,
        employee_no: this.employee_no,
        spokesman_wx_ids: this.allcorp_iduser,
        pull_user_wx_ids,
        group_chat_name_rule: this.textarea,
        max_number: this.max_number,
        max_num_daily: this.max_num_daily,
        pull_group_num: this.pull_group_num,
        tag_ids: this.allarr,
        chat_set_type: this.chat_set_type,
        // eslint-disable-next-line eqeqeq
        chat_set_where: this.chat_set_where,
        ...albocxr
      })
      console.log('data222')
      if (data.code === 200) {
        this.$message.success(this.type === 3 ? '复用成功' : '新增成功')
        this.resetFormData()
        this.$emit('updata')
      }
    },
    handleCloseGroup(item, index) {
      this.corp_iduser_group.splice(index, 1)
      this.corp_ids = []
      this.corp_ids = [...new Set(this.corp_iduser_group.map(item => item.corp_id))]
      this.gettree()
    },
    handleClosewxid(item, index) {
      this.corp_iduserWxId.splice(index, 1)
    },
    handleClose(item, index) {
      this.corp_iduser.splice(index, 1)
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    addidentifit() {
      this.textarea = this.textarea.slice(0, this.blurIndex) + this.addtifit + this.textarea.slice(this.blurIndex)
    },
    fnTree(arr) {
      // 取树状数据的所有子集
      return arr.reduce((prev, cur) => {
        return prev.concat(cur.children && cur.children.length ? this.fnTree(cur.children) : cur)
      }, [])
    },
    // 获取标签
    gettree() {
      // this.corpidarr = this.arrs.map(item => {
      //   return item.corp_id
      // })
      corpTag({
        corp_id: this.corp_ids
      }).then(res => {
        console.log('res', res)
        this.alltagarr = []
        for (let i = 0; i < res.data.length; i++) {
          this.alltagarr.push({
            id: res.data[i].corp_id,
            label: res.data[i].corp_name
          })
        }
        for (let l = 0; l < this.alltagarr.length; l++) {
          this.alltagarr[l].children = []
        }
        for (let i = 0; i < res.data.length; i++) {
          for (let k = 0; k < res.data[i].children.length; k++) {
            // console.log(res.data[k].children)
            this.alltagarr[i].children.push({
              id: res.data[i].children[k].group_id,
              label: res.data[i].children[k].group_name
            })
          }
        }

        for (let r = 0; r < this.alltagarr.length; r++) {
          for (let x = 0; x < this.alltagarr[r].children.length; x++) {
            this.alltagarr[r].children[x].children = []
          }
        }
        for (let u = 0; u < res.data.length; u++) {
          for (let f = 0; f < res.data[u].children.length; f++) {
            // console.log(res.data[u].children[f])
            for (let g = 0; g < res.data[u].children[f].children.length; g++) {
              this.alltagarr[u].children[f].children.push({
                id: res.data[u].children[f].children[g].tag_id,
                label: res.data[u].children[f].children[g].tag_name,
                corp_id: res.data[u].children[f].children[g].corp_id
              })
            }
          }
        }
        this.data = this.alltagarr
        console.log(' this.alltagarr', this.alltagarr)
      })
    },
    datavalue(val) {
      console.log('val', val)
      this.starttime = val[0]
      this.endtime = val[1]
    },
    dayewr() {
      // eslint-disable-next-line eqeqeq
      if (this.fixed_number_of_days < 1 && this.fixed_number_of_days != '') {
        this.fixed_number_of_days = 1
      }
      // 判断不能输入小数点
      const str = '' + this.fixed_number_of_days
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.fixed_number_of_days = 1
      }
    },
    timestampToTime(timestamp) {
      // 时间戳为10位需*1000，时间戳为13位不需乘1000
      var date = new Date(timestamp * 1000)
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      return Y + M + D
    },
    loginplarm(val) {
      console.log('val', val)
      this.employee_no = ''
      this.name = ''
      this.corp_iduser = []
      this.corp_iduser_group = []
      this.corp_ids = []
      // 当 rule_type=1 时，固定欢迎语间隔为 3分钟
      if (val === 1) {
        this.welcome_interval = 1
      }
    },
    handleTemplateInput(val) {
      if (val.length > 50) {
        this.templateText = val.slice(0, 50)
      }
    },
    handleWelcomeInput(val) {
      if (val.length > 50) {
        this.welcomeText = val.slice(0, 50)
      }
    },
    addAvoidHarassTag() {
      const trimmed = this.avoid_harass_input.trim()
      // 去除字符串中所有空格
      const cleaned = trimmed.replace(/\s+/g, '')
      if (cleaned !== '' && !this.avoid_harass.includes(cleaned)) {
        this.avoid_harass.push(cleaned)
      }
      this.avoid_harass_input = ''
    },
    removeAvoidHarassTag(index) {
      this.avoid_harass.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.corp_box {
  height: 200px;
  overflow-y: auto;
}
.pop-box{
  padding:0px 20px;

}
.pop-cell{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:10px 30px;
}
.pop-cell div{
  width:95%;
}
.taewr {
  display: flex;
  align-items: center;
}
.tiwmebox {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
}
.tiwmeboxr {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  text-align: center;
  border-right: 0px;
  line-height: 36px;
  color: #61686b;
  border-radius: 5px 0px 0px 5px;
}
.submit-btn{
  float: right !important;
  margin-right: 10px !important;
}
.pop-title{
  font-size:16px;
  color:#1D2129;
  font-weight:700;
  margin-top:20px;
}
.el-form-item{
  margin-bottom:0px;
}
.pop-title:nth-child(1){
  margin-top:0px !important;
}
.put-box{
  width:150px !important;
  height:36px;
  border:1px solid #ccc;
  border-radius:5px;
  display:flex;
  align-items:center;
  overflow:auto;
  margin-right:10px;
}
@media (max-width: 768px){
  .pop-cell{
    flex-direction:column;
    padding:0px;
    gap:2vw;
  }
  .pop-box{
    padding:0px;
  }
  .pop-cell div{
    width:100%;
  }
  .pop-box .el-form-item--medium .el-form-item__label {
    line-height:auto;
  }

}
</style>
